import {
  useCreate,
  useDelete,
  useDetail,
  useList,
  useUpdate,
  usePartialUpdate,
  useListInfinite,
  usePlainList,
} from '@inmagik/react-crud'
import { AllegatoBilancia, Bilancia, Opportunita } from '../types'
import { API_URL } from '../constants'
import { BilanciaClienteType } from '../typesCliente'

export function useBilanceList(params: Record<string, string> = {}) {
  return useList<Bilancia>(`${API_URL}/bilance/bilancia`, params)
}

export function useBilancia(id: string, enabled: boolean = true) {
  return useDetail<Bilancia>(`${API_URL}/bilance/bilancia`, id, { enabled })
}

export function useCreateBilancia() {
  return useCreate<Bilancia>(`${API_URL}/bilance/bilancia`)
}

export function useUpdateBilancia() {
  return useUpdate<Bilancia>(`${API_URL}/bilance/bilancia`)
}

export function usePartialUpdateBilancia() {
  return usePartialUpdate<Bilancia>(`${API_URL}/bilance/bilancia`, {
    encode: 'formdata',
  })
}

export function useDeleteBilancia() {
  return useDelete(`${API_URL}/bilance/bilancia`)
}

export function useBilanceListInfinite(params: Record<string, string> = {}) {
  return useListInfinite<Bilancia>(`${API_URL}/bilance/bilancia`, params)
}

export function useBilanceScadenze(params: Record<string, string> = {}) {
  return usePlainList<Bilancia>(`${API_URL}/bilance/bilancia/scadenze`, params, {
    enabled: true,
  })
}

export function usePartialUpdateBilanciaJson() {
  return usePartialUpdate<Bilancia>(`${API_URL}/bilance/bilancia`)
}

export function useAllegatiBilancia(params: Record<string, string> = {}) {
  return useList<AllegatoBilancia>(`${API_URL}/bilance/allegato-bilancia`, params)
}

export function useCreateAllegatoBilancia() {
  return useCreate<AllegatoBilancia>(`${API_URL}/bilance/allegato-bilancia`, {
    encode: 'formdata',
  })
}

export function useDeleteAllegatoBilancia() {
  return useDelete(`${API_URL}/bilance/allegato-bilancia`)
}

export function useUpdateAllegatoBiilancia() {
  return useUpdate<AllegatoBilancia>(`${API_URL}/bilance/allegato-bilancia`, {
    encode: 'formdata',
  })
}

// #region AREA CLIENTE
export function useBilanciaCliente(id: string, enabled: boolean = true) {
  return useDetail<BilanciaClienteType>(`${API_URL}/bilance/bilancia`, id, { enabled })
}
